/**
 * API functions for application settings management
 */
import apiClient from '@/lib/axios';
import type { SettingDto, SettingsByCategoryDto, UpdateSettingRequest } from '../types/settings';

// Backend wraps responses in Result<T> type
interface ApiResult<T> {
  success: boolean;
  data: T;
  message?: string;
}

/**
 * Fetch all application settings grouped by category
 */
export const getSettings = async (): Promise<SettingsByCategoryDto[]> => {
  const response = await apiClient.get<ApiResult<SettingsByCategoryDto[]>>('/settings');
  return response.data.data;
};

/**
 * Fetch a single setting by key
 * @param key - The setting key
 */
export const getSetting = async (key: string): Promise<SettingDto> => {
  const response = await apiClient.get<ApiResult<SettingDto>>(`/settings/${key}`);
  return response.data.data;
};

/**
 * Update a setting value
 * @param key - The setting key
 * @param data - The update request containing the new value
 */
export const updateSetting = async (
  key: string,
  data: UpdateSettingRequest
): Promise<SettingDto> => {
  const response = await apiClient.put<ApiResult<SettingDto>>(`/settings/${key}`, data);
  return response.data.data;
};
